import React, { useState } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    tableCellClasses,
    TableContainer,
    TableHead,
    TableRow,
    Switch,
    Button,
    styled,
    CircularProgress,
    Tooltip
} from '@mui/material';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#0a5068',
        color: theme.palette.common.white,
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export default function FeatureUpdateTable({ features, loading, onUpdateFeature }) {
    const [localFeatures, setLocalFeatures] = useState(features);

    const handleStatusChange = (event, featureId) => {
        const updatedFeatures = localFeatures.map(feature =>
            feature.id === featureId ? { ...feature, status: event.target.checked } : feature
        );
        setLocalFeatures(updatedFeatures);
        onUpdateFeature(featureId, { status: event.target.checked });
    };

    const handleFileUpload = (event, featureId) => {
        const file = event.target.files[0];
        if (file) {
            const updatedFeatures = localFeatures.map(feature =>
                feature.id === featureId ? { ...feature, attachment: file } : feature
            );
            setLocalFeatures(updatedFeatures);
            onUpdateFeature(featureId, { attachment: file });
        }
    };

    const formatFeatureName = (feature) => {
        const names = {
            'InversorAndCombiners': 'Inversor e Combinadores',
            'Estacao': 'Estação',
            'Medidor': 'Medidor',
            'Rele': 'Relé',
            'Trackers': 'Trackers',
            'CommunicationMap': 'Mapa de Comunicação',
            'TrackersMap': 'Mapa de Trackers',
            'UnifilarDiagram': 'Diagrama Unifilar'
        };
        return names[feature] || feature;
    };

    const shouldShowFileUpload = (featureName) => {
        return ['CommunicationMap', 'TrackersMap', 'UnifilarDiagram'].includes(featureName);
    };

    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: 200
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <TableContainer>
            <Table stickyHeader aria-label="features table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Feature</StyledTableCell>
                        <StyledTableCell align="center">Status</StyledTableCell>
                        <StyledTableCell align="center">Ações</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {localFeatures.map((feature) => (
                        <StyledTableRow key={feature.id}>
                            <StyledTableCell component="th" scope="row">
                                {formatFeatureName(feature.feature)}
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                <Switch
                                    checked={feature.status}
                                    onChange={(e) => handleStatusChange(e, feature.id)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                    color="primary"
                                />
                            </StyledTableCell>
                            <StyledTableCell align="center">
                                {shouldShowFileUpload(feature.feature) && (
                                    <Tooltip
                                        title={!feature.status ? "Ative a feature para enviar arquivos" : ""}
                                        placement="top"
                                    >
                                        <span>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                style={{
                                                    color: feature.status ? '#0a5068' : '#ccc',
                                                    borderColor: feature.status ? '#0a5068' : '#ccc',
                                                    textTransform: 'none',
                                                    width: '100%'
                                                }}
                                                disabled={!feature.status}
                                            >
                                                {feature.attachment ? 'Arquivo selecionado' : 'Selecionar arquivo'}
                                                <input
                                                    type="file"
                                                    hidden
                                                    onChange={(e) => handleFileUpload(e, feature.id)}
                                                    disabled={!feature.status}
                                                />
                                            </Button>
                                        </span>
                                    </Tooltip>
                                )}
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};